var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-card-testimonial',{attrs:{"comments":_vm.comments,"user-name":_vm.userName,"user-title":_vm.userTitle,"user-picture":_vm.userPicture}})
}
var staticRenderFns = []

export { render, staticRenderFns }